<template>
  <div class="strict">
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav class="strict-nav" /><!-- 顶部导航-->
    <Banner />
    <div class="strict-devices">
      <div class="strict-devicesInner">
        <div v-for="(item, index) in parentCates" :key="index" class="device">
          <h1 class="strict-title">{{ item.serviceCategoryName }}</h1>
          <div class="strict-content">
            <Devices :cateId="item.serviceCategoryId" />
            <BlockType
              :items="item.child"
              :index="index"
              :title="item.serviceCategoryName"
            />
          </div>
          <div class="more flex flex-center">
            <span
              class="pointer"
              :style="{
                background: itemColorMap[index],
              }"
              @click="moreClick(item)"
              >查看更多</span
            >
          </div>
        </div>
      </div>
    </div>
    <FootBar class="footBar" />
  </div>
</template>
<script>
import Banner from "./components/Bnnner.vue";
import BlockType from "./components/BlockType.vue";
import Devices from "./components/Devices.vue";
import { queryKind } from "@/api/mall";
export default {
  components: {
    Banner,
    BlockType,
    Devices,
  },
  data() {
    return {
      parentCates: [],
      loading: false,
      itemColorMap: {
        0: "#7EBCF2",
        1: "#EEAB6C",
        2: "#F26F71",
      },
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    moreClick(item) {
      console.log(item);
      this.$router.push({
        name: "mallStrict",
        query: { cateId: item.serviceCategoryId },
      });
    },
    async getCategory() {
      // 获取顶级分类
      this.loading = true;
      const pData = await this.$axios
        .get(queryKind, {
          superCategoryId: 0,
        })
        .finally(() => {
          this.loading = false;
        });
      pData.forEach((item) => {
        Object.assign(item, { child: [] });
      });
      this.parentCates = pData;
      pData.forEach(async (item) => {
        const child = await this.$axios.get(queryKind, {
          superCategoryId: item.serviceCategoryId,
        });
        Object.assign(item, { child });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.strict {
  &-title {
    text-align: center;
    background: url($oss-url + "home/title-bg/title-bg-3.png") no-repeat center
      center/contain;
    font-size: 18px;
    padding: 20px;
  }
  &-devices {
    padding: 30px 0;
    min-height: 500px;
    background: #f0f0f8;
  }
  &-devicesInner {
    width: $max-width;
    margin: 0 auto;
  }
  &-content {
    margin: 20px 0;
    display: grid;
    grid-template-columns: auto 215px;
    gap: 20px;
  }
}

.more {
  text-align: center;
  span {
    color: white;
    padding: 5px 60px;
  }
}
.device {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.footBar {
  padding-top: 0;
}
</style>
